// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/onboarding.proto (package tickettally.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/onboarding.proto.
 */
export const file_v1_onboarding: GenFile = /*@__PURE__*/
  fileDesc("ChN2MS9vbmJvYXJkaW5nLnByb3RvEg50aWNrZXR0YWxseS52MSI1ChpHZXRPbmJvYXJkaW5nU3RhdHVzUmVxdWVzdBIXCg9vbmJvYXJkaW5nX3R5cGUYASABKAki/wEKG0dldE9uYm9hcmRpbmdTdGF0dXNSZXNwb25zZRIRCgljb21wbGV0ZWQYASABKAgSFAoMY3VycmVudF9zdGVwGAIgASgFEg8KB3NraXBwZWQYAyABKAgSLgoKc3RhcnRlZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMAoMY29tcGxldGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIUCgxzaG91bGRfb2ZmZXIYBiABKAgSLgoKc2tpcHBlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiUAofVXBkYXRlT25ib2FyZGluZ1Byb2dyZXNzUmVxdWVzdBIXCg9vbmJvYXJkaW5nX3R5cGUYASABKAkSFAoMY3VycmVudF9zdGVwGAIgASgFIkQKIFVwZGF0ZU9uYm9hcmRpbmdQcm9ncmVzc1Jlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgSDwoHbWVzc2FnZRgCIAEoCSIwChVTa2lwT25ib2FyZGluZ1JlcXVlc3QSFwoPb25ib2FyZGluZ190eXBlGAEgASgJIjoKFlNraXBPbmJvYXJkaW5nUmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBIPCgdtZXNzYWdlGAIgASgJIjQKGUNvbXBsZXRlT25ib2FyZGluZ1JlcXVlc3QSFwoPb25ib2FyZGluZ190eXBlGAEgASgJIj4KGkNvbXBsZXRlT25ib2FyZGluZ1Jlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgSDwoHbWVzc2FnZRgCIAEoCSIxChZSZXNldE9uYm9hcmRpbmdSZXF1ZXN0EhcKD29uYm9hcmRpbmdfdHlwZRgBIAEoCSI7ChdSZXNldE9uYm9hcmRpbmdSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIEg8KB21lc3NhZ2UYAiABKAkytAQKEU9uYm9hcmRpbmdTZXJ2aWNlEm4KE0dldE9uYm9hcmRpbmdTdGF0dXMSKi50aWNrZXR0YWxseS52MS5HZXRPbmJvYXJkaW5nU3RhdHVzUmVxdWVzdBorLnRpY2tldHRhbGx5LnYxLkdldE9uYm9hcmRpbmdTdGF0dXNSZXNwb25zZRJ9ChhVcGRhdGVPbmJvYXJkaW5nUHJvZ3Jlc3MSLy50aWNrZXR0YWxseS52MS5VcGRhdGVPbmJvYXJkaW5nUHJvZ3Jlc3NSZXF1ZXN0GjAudGlja2V0dGFsbHkudjEuVXBkYXRlT25ib2FyZGluZ1Byb2dyZXNzUmVzcG9uc2USXwoOU2tpcE9uYm9hcmRpbmcSJS50aWNrZXR0YWxseS52MS5Ta2lwT25ib2FyZGluZ1JlcXVlc3QaJi50aWNrZXR0YWxseS52MS5Ta2lwT25ib2FyZGluZ1Jlc3BvbnNlEmsKEkNvbXBsZXRlT25ib2FyZGluZxIpLnRpY2tldHRhbGx5LnYxLkNvbXBsZXRlT25ib2FyZGluZ1JlcXVlc3QaKi50aWNrZXR0YWxseS52MS5Db21wbGV0ZU9uYm9hcmRpbmdSZXNwb25zZRJiCg9SZXNldE9uYm9hcmRpbmcSJi50aWNrZXR0YWxseS52MS5SZXNldE9uYm9hcmRpbmdSZXF1ZXN0GicudGlja2V0dGFsbHkudjEuUmVzZXRPbmJvYXJkaW5nUmVzcG9uc2VCKFomZ2l0aHViLmNvbS9kdWNidC90dC1nby9nZW4vcHJvdG8vdjE7djFiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * @generated from message tickettally.v1.GetOnboardingStatusRequest
 */
export type GetOnboardingStatusRequest = Message<"tickettally.v1.GetOnboardingStatusRequest"> & {
  /**
   * e.g., "initial_tour", "telegram_tour"
   *
   * @generated from field: string onboarding_type = 1;
   */
  onboardingType: string;
};

/**
 * Describes the message tickettally.v1.GetOnboardingStatusRequest.
 * Use `create(GetOnboardingStatusRequestSchema)` to create a new message.
 */
export const GetOnboardingStatusRequestSchema: GenMessage<GetOnboardingStatusRequest> = /*@__PURE__*/
  messageDesc(file_v1_onboarding, 0);

/**
 * @generated from message tickettally.v1.GetOnboardingStatusResponse
 */
export type GetOnboardingStatusResponse = Message<"tickettally.v1.GetOnboardingStatusResponse"> & {
  /**
   * @generated from field: bool completed = 1;
   */
  completed: boolean;

  /**
   * @generated from field: int32 current_step = 2;
   */
  currentStep: number;

  /**
   * @generated from field: bool skipped = 3;
   */
  skipped: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 4;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 5;
   */
  completedAt?: Timestamp;

  /**
   * True when the client should offer this onboarding now. A skipped flow is
   * offered again only for types with a re-offer policy (bet_limit_tour:
   * every 3 days after the last skip, within 30 days of the first offer).
   *
   * @generated from field: bool should_offer = 6;
   */
  shouldOffer: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp skipped_at = 7;
   */
  skippedAt?: Timestamp;
};

/**
 * Describes the message tickettally.v1.GetOnboardingStatusResponse.
 * Use `create(GetOnboardingStatusResponseSchema)` to create a new message.
 */
export const GetOnboardingStatusResponseSchema: GenMessage<GetOnboardingStatusResponse> = /*@__PURE__*/
  messageDesc(file_v1_onboarding, 1);

/**
 * @generated from message tickettally.v1.UpdateOnboardingProgressRequest
 */
export type UpdateOnboardingProgressRequest = Message<"tickettally.v1.UpdateOnboardingProgressRequest"> & {
  /**
   * @generated from field: string onboarding_type = 1;
   */
  onboardingType: string;

  /**
   * @generated from field: int32 current_step = 2;
   */
  currentStep: number;
};

/**
 * Describes the message tickettally.v1.UpdateOnboardingProgressRequest.
 * Use `create(UpdateOnboardingProgressRequestSchema)` to create a new message.
 */
export const UpdateOnboardingProgressRequestSchema: GenMessage<UpdateOnboardingProgressRequest> = /*@__PURE__*/
  messageDesc(file_v1_onboarding, 2);

/**
 * @generated from message tickettally.v1.UpdateOnboardingProgressResponse
 */
export type UpdateOnboardingProgressResponse = Message<"tickettally.v1.UpdateOnboardingProgressResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message tickettally.v1.UpdateOnboardingProgressResponse.
 * Use `create(UpdateOnboardingProgressResponseSchema)` to create a new message.
 */
export const UpdateOnboardingProgressResponseSchema: GenMessage<UpdateOnboardingProgressResponse> = /*@__PURE__*/
  messageDesc(file_v1_onboarding, 3);

/**
 * @generated from message tickettally.v1.SkipOnboardingRequest
 */
export type SkipOnboardingRequest = Message<"tickettally.v1.SkipOnboardingRequest"> & {
  /**
   * @generated from field: string onboarding_type = 1;
   */
  onboardingType: string;
};

/**
 * Describes the message tickettally.v1.SkipOnboardingRequest.
 * Use `create(SkipOnboardingRequestSchema)` to create a new message.
 */
export const SkipOnboardingRequestSchema: GenMessage<SkipOnboardingRequest> = /*@__PURE__*/
  messageDesc(file_v1_onboarding, 4);

/**
 * @generated from message tickettally.v1.SkipOnboardingResponse
 */
export type SkipOnboardingResponse = Message<"tickettally.v1.SkipOnboardingResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message tickettally.v1.SkipOnboardingResponse.
 * Use `create(SkipOnboardingResponseSchema)` to create a new message.
 */
export const SkipOnboardingResponseSchema: GenMessage<SkipOnboardingResponse> = /*@__PURE__*/
  messageDesc(file_v1_onboarding, 5);

/**
 * @generated from message tickettally.v1.CompleteOnboardingRequest
 */
export type CompleteOnboardingRequest = Message<"tickettally.v1.CompleteOnboardingRequest"> & {
  /**
   * @generated from field: string onboarding_type = 1;
   */
  onboardingType: string;
};

/**
 * Describes the message tickettally.v1.CompleteOnboardingRequest.
 * Use `create(CompleteOnboardingRequestSchema)` to create a new message.
 */
export const CompleteOnboardingRequestSchema: GenMessage<CompleteOnboardingRequest> = /*@__PURE__*/
  messageDesc(file_v1_onboarding, 6);

/**
 * @generated from message tickettally.v1.CompleteOnboardingResponse
 */
export type CompleteOnboardingResponse = Message<"tickettally.v1.CompleteOnboardingResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message tickettally.v1.CompleteOnboardingResponse.
 * Use `create(CompleteOnboardingResponseSchema)` to create a new message.
 */
export const CompleteOnboardingResponseSchema: GenMessage<CompleteOnboardingResponse> = /*@__PURE__*/
  messageDesc(file_v1_onboarding, 7);

/**
 * @generated from message tickettally.v1.ResetOnboardingRequest
 */
export type ResetOnboardingRequest = Message<"tickettally.v1.ResetOnboardingRequest"> & {
  /**
   * @generated from field: string onboarding_type = 1;
   */
  onboardingType: string;
};

/**
 * Describes the message tickettally.v1.ResetOnboardingRequest.
 * Use `create(ResetOnboardingRequestSchema)` to create a new message.
 */
export const ResetOnboardingRequestSchema: GenMessage<ResetOnboardingRequest> = /*@__PURE__*/
  messageDesc(file_v1_onboarding, 8);

/**
 * @generated from message tickettally.v1.ResetOnboardingResponse
 */
export type ResetOnboardingResponse = Message<"tickettally.v1.ResetOnboardingResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message tickettally.v1.ResetOnboardingResponse.
 * Use `create(ResetOnboardingResponseSchema)` to create a new message.
 */
export const ResetOnboardingResponseSchema: GenMessage<ResetOnboardingResponse> = /*@__PURE__*/
  messageDesc(file_v1_onboarding, 9);

/**
 * @generated from service tickettally.v1.OnboardingService
 */
export const OnboardingService: GenService<{
  /**
   * Get user's onboarding status for a specific onboarding type
   *
   * @generated from rpc tickettally.v1.OnboardingService.GetOnboardingStatus
   */
  getOnboardingStatus: {
    methodKind: "unary";
    input: typeof GetOnboardingStatusRequestSchema;
    output: typeof GetOnboardingStatusResponseSchema;
  },
  /**
   * Update user's onboarding progress
   *
   * @generated from rpc tickettally.v1.OnboardingService.UpdateOnboardingProgress
   */
  updateOnboardingProgress: {
    methodKind: "unary";
    input: typeof UpdateOnboardingProgressRequestSchema;
    output: typeof UpdateOnboardingProgressResponseSchema;
  },
  /**
   * Skip onboarding
   *
   * @generated from rpc tickettally.v1.OnboardingService.SkipOnboarding
   */
  skipOnboarding: {
    methodKind: "unary";
    input: typeof SkipOnboardingRequestSchema;
    output: typeof SkipOnboardingResponseSchema;
  },
  /**
   * Mark onboarding as completed
   *
   * @generated from rpc tickettally.v1.OnboardingService.CompleteOnboarding
   */
  completeOnboarding: {
    methodKind: "unary";
    input: typeof CompleteOnboardingRequestSchema;
    output: typeof CompleteOnboardingResponseSchema;
  },
  /**
   * Reset onboarding to initial state (for restarting the tour)
   *
   * @generated from rpc tickettally.v1.OnboardingService.ResetOnboarding
   */
  resetOnboarding: {
    methodKind: "unary";
    input: typeof ResetOnboardingRequestSchema;
    output: typeof ResetOnboardingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_onboarding, 0);

